import { Injectable, inject } from '@angular/core';
import Session from '../utils/session.service';
import Config from '../utils/config.service';
import ChatService from '../services/chat.service';
import UserRestServices from '../services/user-rest.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';

@Injectable({ providedIn: 'root' })
export default class PushNotificationService {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private chatService: ChatService = inject(ChatService);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	ws: any = undefined;
	authenticated: any = false;
	pingStarted: any = false;
	
	constructor() {
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.INIT_PUSH_NOTIFICATIONS, (event, session) => {
			this.startWebSocket();
		});
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.LOGOUT, (event) => {
			this.disconnect();
		});
	}
	
	init() {
		// TODO ANGULAR_2 move constructor code here
	}
	
	startWebSocket() {
		if (this.session.isLoggedIn()) {
			var env: any = this.config.getSettings().ENVIRONMENT.toLowerCase();
			if (env == "{{environment}}") {
				this.ws = new WebSocket("wss://push-devel.minudoc.ee/websocket/");
			} else {
				this.ws = new WebSocket("wss://push.minudoc.ee/websocket/");
			}
			this.ws.onopen = (event) => {
				this.authenticate();
			};
			this.ws.onmessage = (event) => {
				var pushObject: any = JSON.parse(event.data);
				if (pushObject.type == 'CHAT_POST') {
					console.log("Push WS: NEW CHAT MESSAGE");
					var messages: Array<any> = [];
					messages.push(pushObject.chatPost);
					this.chatService.handleNewMessages(messages);
				} else if (pushObject.type == 'RESPONSE' && pushObject.data == 'AUTHENTICATED') {
					this.authenticated = true;
					console.log("Push WS: AUTHENTICATED");
				}
			}
			this.ws.onclose = (event) => {
				this.authenticated = false;
				console.log("Push WS: CLOSING", new Date());
			}
			this.ws.onerror = (event) => {
				console.log("Push WS: ERROR", new Date());
			}
		}
	}
	
	authenticate() {
		var sessionCookie: any = this.getCookie('SENTAB_SESSION_ID');
		if (!sessionCookie) {
			this.userRestServices.getSessionId({}, (session) => {
				if (session) {
					var sessionId: any = session.sessionId;
					this.authenticateUsingSessionId(sessionId);
				}
			});
		} else {
			this.authenticateUsingSessionId(sessionCookie);
		}
	}
	
	authenticateUsingSessionId(sessionId) {
		if (sessionId) {
			var env: any = this.config.getSettings().ENVIRONMENT.toLowerCase();
			if (env == "{{environment}}") {
				env = "devel";
			}
			if (this.ws.readyState == 1) {
				this.ws.send('{"type":"AUTH","env":"' + env + '","data":"'+ sessionId +'"}');
			}
			
		}
		if (!this.pingStarted) {
			this.pingStarted = true;
			setInterval(() => {
				this.ping();
			}, 30000);
		}
	}
	
	getCookie(cname) {
		var name: any = cname + "=";
		var ca: any = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c: any = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	
	ping() {
		if (this.ws.readyState == 1 && this.authenticated) {
			this.ws.send('{"type":"PING"}');
		} else {
			this.startWebSocket();
		}
	}
	
	disconnect() {
		if (this.ws && this.ws.readyState == 1) {
			this.authenticated = false;
			this.ws.close();
		}
	}
	
}
